import React, { Component, PropTypes } from 'react';
import SendEmailCard from './send-email-card';
import { Dialog, FlatButton } from 'material-ui';
import SectionHeading from '../tc-ui/section-heading';
import { RaisedButton } from 'material-ui';

class TempConnectionsSend extends Component {

  constructor(props) {
    super(props);
    this.state = {
      emailErrorDialog: false,
    };
  }

  getEmailErrorDialog = () => {
    const actions = [
      <FlatButton
        label="Ok"
        onTouchTap={this.dismissDialog}
        secondary
      />,
    ];
    return (
      <Dialog
        className="form-dialog"
        title="There Was An Error Sending Your Email"
        ref="emailErrorDialog"
        actions={actions}
        onRequestClose={this.dismissDialog}
        open={this.state.emailErrorDialog}
      >
        {'There was an error sending your email. Please resend your email. If the error persists, please reach out for technical assistance or start over'}
      </Dialog>
    );
  };

  dismissDialog = () => {
    this.setState({ emailErrorDialog: false });
  };

  sendEmail = () => {
    const { history, tempConnections, sendEmailToTempConnections } = this.props;
    sendEmailToTempConnections(tempConnections.get('emailValue'))
    .then((res) => {
      if (res.payload.report) history.push('/connections/add-connections/results');
    })
    .catch(() => {
      this.setState({ 'emailErrorDialog': true });
    });
  };

  goBack = () => {
    const { isPersistedFromServer, history } = this.props;
    isPersistedFromServer();
    history.push('/connections/add-connections');
  };

  render() {
    const errorDialog = this.getEmailErrorDialog();
    return (
      <div>
        <SectionHeading
          title="Personalize Your Invitations"
          subtitle={'Enter an optional message or just click send to send your invitations now!'}
          style={{ marginTop: '64px' }}
        />
        <SendEmailCard {...this.props} />
        <div style={{ margin: '24px auto auto auto', width: '512px' }}>
        <RaisedButton
          label="Back"
          type="button"
          secondary
          onClick={this.goBack}
        />
        <RaisedButton
          style={{ float: 'right' }}
          label="Send"
          type="button"
          disabled={!this.props.tempConnections.get('emailValidLength') || this.props.tempConnections.get('sendingEmails')}
          primary={this.props.tempConnections.get('emailValidLength')}
          onClick={this.sendEmail}
        />
        </div>
          {errorDialog}
        </div>
    );
  }
}

TempConnectionsSend.propTypes = {
  changeEmailValue: PropTypes.func,
  tempConnections: PropTypes.object,
  sendEmailToTempConnections: PropTypes.func,
  history: PropTypes.object,
  isPersistedFromServer: PropTypes.func,
};

export default TempConnectionsSend;



// WEBPACK FOOTER //
// ./src/app/components/temp-connections/temp-connections-send.jsx